import { createReducer } from 'typesafe-actions';
import { purge } from '../auth/actions';
import {
  clearSentEmailStatus,
  getContacts,
  getTelsAndEmails,
  selectContact,
  sendEmail,
} from './actions';

const INITIAL_STATE: ContactsState = {
  sentEmailMessage: undefined,
};

const contactsReducer = createReducer<ContactsState>(INITIAL_STATE)
  .handleAction(purge, () => INITIAL_STATE)
  .handleAction(getContacts.success, (state, action) => ({
    ...state,
    list: action.payload,
    selected: undefined,
    contactsLoading: false,
  }))
  .handleAction(getContacts.request, (state, action) => ({
    ...state,
    list: [],
    contactsLoading: true,
  }))
  .handleAction(getContacts.failure, (state, action) => ({
    ...state,
    contactsLoading: false,
  }))
  .handleAction(getTelsAndEmails.success, (state, action) => ({
    ...state,
    contactsLists: action.payload,
    selected: undefined,
    contactsLoading: false,
  }))
  .handleAction(getTelsAndEmails.request, (state, action) => ({
    ...state,
    contactsLists: [],
    contactsLoading: true,
  }))
  .handleAction(getTelsAndEmails.failure, (state, action) => ({
    ...state,
    contactsLoading: false,
  }))
  .handleAction(sendEmail.success, (state, action) => ({
    ...state,
    sentEmailMessage: action.payload,
  }))
  .handleAction(sendEmail.failure, (state, action) => ({
    ...state,
    sentEmailMessage: action.payload,
  }))
  .handleAction(clearSentEmailStatus, (state, action) => ({
    ...state,
    sentEmailMessage: undefined,
  }))
  .handleAction(selectContact, (state, action) => ({
    ...state,
    selected: action.payload,
  }));

export default contactsReducer;
